import React from 'react';
import Grid from '@mui/material/Grid';

import CardsContainer from '../../../context/search-context/SearchResults/CardsContainer';
import { EventVendorCard } from '../EventVendorCard';

import type { EventSelectedVendorsProps } from './types';

export default function EventSelectedVendors({
  vendors = [],
  ...props
}: EventSelectedVendorsProps) {
  return (
    <CardsContainer {...props}>
      {vendors?.map((vendor) => {
        return (
          <Grid
            id={vendor.vendorNameId}
            item
            key={vendor.vendorNameId}
            lg={4}
            md={6}
            sx={{ '&.MuiGrid-item': { padding: 0 } }}
            xs={12}
          >
            <EventVendorCard data={vendor} />
          </Grid>
        );
      })}
    </CardsContainer>
  );
}
